import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'
import { useProjectStore } from '@/stores/project';
import { useIdentityStore } from '@/stores/identity';

export async function buildPayrollHandover() {
  


  const identity = useIdentityStore();
  const project = useProjectStore();

    //Only show the card to admins as this is an internal task
    if(identity.type !== 'Administrator') return null;

    var milestones = project.milestones;    

    // Check if the trigger milestone (Parallel Run) is completed before showing the Payroll Handover card
    const triggerMilestone = milestones.find(m => m.type === 'ParallelRun');
    if(triggerMilestone == null || triggerMilestone.status !== 'SuccessfullyCompleted') {
      return null;
    }

    const milestone = milestones.find(m => m.type === 'PayrollHandover');
    if(milestone == null) {
      return null;
    }

    const card = {
    id: milestone.milestoneId,
    title: 'Payroll Handover',
    subtitle: 'Carry out a handover with the payroll team to ensure they are ready for the customer.',
    progress: 0,
    subProgressMessage: formatDateToWrittenDate(milestone.scheduledCompletion),
    status: milestone.status,
    route: '/tasks/internal-milestone/' + milestone.milestoneId, 
    createdDate: new Date(milestone.scheduledCompletion)
  }

  return card 
}

